// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseModal_close__77nBU","bar":"CloseModal_bar__Cf5dv","float":"CloseModal_float__7AvQu","margin":"CloseModal_margin__JKIED"};